const minin = {
  data() {
    return {
      baseUrl: 'order',
      submitUrl: 'addhire',
      sform: {
        car_type: undefined,
        license: undefined,
      },
      sformCtrl: [
        {
          label: "车辆类型",
          keyName: "car_type",
          type: "select",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
        },
      ],
      form: {
        license: '',
        predict_loading_date: '',
        predict_unloading_date: '',
        name: '',
        cmessage: null,
        shipperid: '',
        pcustomname: '',
        coaddress: '',
        enaddress: '',
        inton: null,
        unton: null,
        invoice: null,
        uninvoice: null,
        cprice: null,
        dprice: null,
        dtonprice: null,
        repaytime: null,
        istime: null,
        insurance: null,
        fuel: null,
        exceeded: null,
        pricing_id: null,
      },
      rules: {
        pricing_id: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        license: [
          { required: true, message: "请选择车牌号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        shname: [
          { required: true, message: "请选择客户名称", trigger: "blur" },
        ],
        pcustomname: [
          { required: true, message: "请填写承运公司", trigger: "blur" },
        ],
        predict_loading_date: [
          { required: true, message: "请选择装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请选择卸货日期", trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
        inton: [
          {
            required: true,
            // message: "请填写装货量",
            validator: this.checkInTon,
            trigger: "blur"
          },
        ],
        unton: [
          {
            required: true,
            // message: "请填写卸货量",
            validator: this.checkUnTon,
            trigger: "blur"
          },
        ],
        invoice: [
          { required: true, message: "请上传装货单", trigger: "blur" },
        ],
        uninvoice: [
          { required: true, message: "请上传卸货单", trigger: "blur" },
        ],
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" },
        ],
        // dtonprice: [
        //   { required: true, message: "请填写亏吨单价", trigger: "blur" },
        // ],
      },
      formCtrl: [
        {
          label: "承运公司",
          keyName: "pcustomname",
          err: "请填写承运公司",
          type: "text",
          disabled: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请选择客户名称",
          type: "select",
          options: [],
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请选择货物名称",
          type: "select",
          options: [],
        },
        // {
        //   label: "信息费",
        //   keyName: "cmessage",
        //   err: "请填写信息费",
        //   type: "number",
        // },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          className: "unton",
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "计价方式",
          keyName: "pricing_name",
          type: "select",
          options: [],
        },
        {
          label: "运费单价",
          keyName: "cprice",
          err: "请填写运费单价",
          type: "number",
        },
        {
          label: "承运单价",
          keyName: "dprice",
          err: "请填写承运单价",
          type: "number",
        },
        {
          label: "装货量",
          keyName: "inton",
          err: "请填写装货量",
          type: "number",
        },
        {
          label: "卸货量",
          keyName: "unton",
          err: "请填写卸货量",
          type: "number",
        },
      ],
      kuitonCtrl: {
        label: "亏吨重量",
        keyName: "kuiton",
        err: "请填写亏吨重量",
        type: "text",
        viewMode: true,
      },
      formCtrlOrder2: [
        {
          label: "装货单",
          keyName: "invoice",
          err: "请上传装货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          max: 1,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请上传卸货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          className: "unton",
          max: 1,
        },
      ],
      // 亏吨信息
      formCtrlWeight: [
        {
          label: "计算量",
          keyName: "caton",
          err: "请填写计算量",
          type: "number",
        },
        {
          label: "客担亏吨(吨)",
          keyName: "ceton",
          err: "请填写客担亏吨",
          type: "number",
        },
        {
          label: "亏吨单价(元/吨)",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写默认不计算亏吨金额",
        },
      ],
      // 预计结款日期
      formCtrlTime: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          err: "请填写预计结款日期",
          type: "date",
          tips: "不填写则默认没有预计结款日期",
          // className: "block",
        },
      ],
      istimeCtrl: {
        label: "结款提醒",
        keyName: "istime_name",
        type: "text",
        viewMode: true,
      },
      // 附加费用，客户信息费字段不同于自有车辆
      formCtrlfee: [
        // {
        //   label: "信息费",
        //   keyName: "cmessage",
        //   type: "number",
        // },
        // {
        //   label: "保险费",
        //   keyName: "insurance",
        //   type: "number",
        // },
        // {
        //   label: "燃油附加费",
        //   keyName: "fuel",
        //   type: "number",
        // },
        // {
        //   label: "超限附加费",
        //   keyName: "exceeded",
        //   type: "number",
        // },
      ],
      cars: [],
      custom: [],
      contract: [],
    };
  },
  methods: {
    formOrtherValidate() {
      let boo = true
      const { car_list, predict_loading_date, predict_unloading_date } = this.form
      if (this.mode === 'add' && (!car_list || !car_list.length)) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
        boo = false
      } else if (new Date(predict_loading_date).getTime() > new Date(predict_unloading_date).getTime()) {
        this.$message({
          type: 'error',
          message: '装货日期不能晚于卸货日期！'
        });
        boo = false
      }
      return boo
    },

    onChecked(arr) {
      console.log('select', arr)
      this.form.car_list = []
      this.cars.map(v => {
        if (arr.includes(v.id)) {
          // console.log({...v})
          this.form.car_list.push({
            car_id: v.id,
            pcustomid: v.pcusid,
          })
        }
      })
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (key === 'pricing_name') {
        this.$set(this.form, key, value)
        this.pricing.map(v => {
          if (value === v.name) {
            this.$set(this.form, 'pricing_id', v.id)
          }
        })
      } else if (key.includes('additional_fee')) {
        this.ExtraFeeChange(key, value)
      } else if (key === 'license') {
        this.$set(this.form, key, value)
        this.cars.map(v => {
          if (value === v.license) {
            this.$set(this.form, 'pcusid', v.pcusid)
            // console.log({...v})
            this.getPcustomname()
          }
        })
      } else if (key === 'contractid') {
        this.$set(this.form, key, value)
        this.contract.map(v => {
          if (value === v.id) {
            this.$set(this.form, 'pricing_id', v.pricing_id)
            this.$set(this.form, 'cprice', v.cprice)
            // this.form['dprice'] = v.dprice
            // console.log({...v})
          }
        })
      } else if (['invoice', 'uninvoice'].includes(key) && value && value[0].response) {
        this.$set(this.form, key, value[0].response.photo)
      } else if (key === 'shname') {
        this.$set(this.form, key, value)
        if (this.custom && this.custom.length) {
          this.custom.map(v => {
            if (value === `${v.name}-${v.member}`) {
              this.$set(this.form, 'shipperid', v.id)
              // console.log({...v})
            }
          })
        }
      } else {
        this.$set(this.form, key, value)
      }
      // 表单赋值之后再计算亏吨重量
      if (['inton', 'unton'].includes(key) && this.form.pricing_id == 1) {
        this.calcKuiton()
      }
      // console.log('form', { ...this.form });
    },
    calcKuiton() {
      const inton = this.form['inton'];
      const unton = this.form['unton'];
      // console.log(inton, unton)
      if (inton && unton) {
        this.$set(this.form, 'kuiton', (inton - unton).toFixed(2) + '吨')
      }
    },
    getPcustomname() {
      // this.form.pcustomname = ''
      const url = 'hirecar/addlicense'
      const params = { pcusid: this.form['pcusid'] }
      this.post(url, params, ({ msg, data }) => {
        // console.log(data)
        if (msg == 'success' && data) {
          this.$set(this.form, 'pcustomname', data.company)
          // this.form.cprice = data.cprice
          this.$set(this.form, 'pcustomid', data.id)
          this.$forceUpdate()
        } else {
          console.log('err')
          this.$message({
            type: 'error',
            message: '未检索到承运公司信息！'
          });
        }
        // console.log('form', { ...this.form });
      })
    },
    getVtype() {
      // 这里获取的是全部车辆类型，包括设置关闭的
      let url = "cartype/rec";
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // const { msg, data } = res
        console.log(res.data)
        this.sformCtrl.map(c => {
          if (c.keyName == 'car_type') {
            res.data.map(v => {
              c.options.push({
                label: v.name,
                value: v.name,
              })
            })
          }
        })
      }, err => {
        console.log(err)
      })
    },
    onSearch() {
      this.getCar();
    },
    onModalReset() {
      this.sform = {
        car_type: undefined,
        license: undefined,
      }
      this.getCar();
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (['car_type'].includes(key)) {
        this.getCar()
      }
    },
    getCar() {
      let url = "contract/adduncar";
      const params = {
        userid: this.user.id,
        ...this.sform
      }
      this.post(url, params, (res) => {
        // const { msg, data } = res
        console.log(res)

        const { hirecar } = res

        this.cars = [];
        if (hirecar && hirecar.length) {
          hirecar.map(v => {
            this.cars.push(v)
          })
        }
      }, err => {
        console.log(err)
      })
    },
    onToggle(boo) {
      // console.log(boo)
      boo ? (this.$set(this.form, 'istime', 1)) : (this.$set(this.form, 'istime', 2))
      // console.log('form', { ...this.form })
    },
    setOptions({ contract, car_type, hirecar, product, custom, pricing, additional_fee_options }) {
      // 储存车辆类型用于检索
      if (car_type && car_type.length) {
        this.sformCtrl.map(c => {
          if (c.keyName == 'car_type') {
            car_type.map(v => {
              c.options.push({
                label: v.name,
                value: v.name,
              })
            })
          }
        })
      }

      this.formCtrl.map(c => {
        if (c.keyName == 'contractid' && contract && contract.length) {
          this.contract = contract
          c.options = contract.map(v => {
            return {
              label: v.con_num + '-' + v.shname,
              value: v.id,
            }
          })
        } else if (c.keyName == 'license' && hirecar && hirecar.length) {
          this.cars = [...hirecar]
          c.options = hirecar.map(v => {
            return {
              label: v.license,
              value: v.license,
            }
          })
        } else if (c.keyName == 'name' && product && product.length) {
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        } else if (c.keyName == 'shname' && custom && custom.length) {
          this.custom = [...custom]
          c.options = custom.map(v => {
            return {
              label: `${v.name}-${v.member}`,
              value: `${v.name}-${v.member}`,
            }
          })

          this.setCustom()
        }
      })
      
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'pricing_name') {
          this.setPricingOption(pricing, c.options)
          if (!this.detail['pricing_id']) {
            this.$set(this.form, 'pricing_id', pricing[0]['id'])
            this.$set(this.form, 'pricing_name', pricing[0]['name'])
          } else {
            // 如果detail先到则在这里匹配
            this.setPricingName()
          }
        }
      })

      // 附加费用
      if (additional_fee_options && additional_fee_options.length && !this.formCtrlfee.length) {
        const o = additional_fee_options
        o.map(v => {
          const ctrl = {
            label: v.authname,
            keyName: v.enname,
            type: "number",
          }
          this.formCtrlfee.push(ctrl)
        })
      }

      // console.log('form', { ...this.form });
    },

    setCustom() {},

    getOptions(params = {}) {
      this.post(`contract/adduncar`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getAllCtrls() {
      const formCtrl = [...this.formCtrl]
      if (this.kuitonCtrl) {
        formCtrl.push(this.kuitonCtrl)
      }
      const In = this.formCtrlIn
      if (In && In.length) {
        formCtrl.push(...In)
      }
      const Out = this.formCtrlOut
      if (Out && Out.length) {
        formCtrl.push(...Out)
      }
      const Order = this.formCtrlOrder
      if (Order && Order.length) {
        formCtrl.push(...Order)
      }
      const Order2 = this.formCtrlOrder2
      if (Order2 && Order2.length) {
        formCtrl.push(...Order2)
      }
      const Order3 = this.formCtrlOrder3
      if (Order3 && Order3.length) {
        formCtrl.push(...Order3)
      }
      const Weight = this.formCtrlWeight
      if (Weight && Weight.length) {
        formCtrl.push(...Weight)
      }
      const f2 = this.formCtrlTime
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      const f3 = this.formCtrl3
      if (f3 && f3.length) {
        formCtrl.push(...f3)
      }
      const ff = this.formCtrlfee
      if (ff && ff.length) {
        formCtrl.push(...ff)
      }
      return formCtrl
    },
    paramsPackage(params, object) {
      // console.log('params', { ...params })
      const keys = this.getAllCtrls().map(v => v.keyName)
      for (const key in object) {
        if (
          Object.hasOwnProperty.call(object, key) &&
          [
            ...keys,
            'car_list',
            'shipperid',
            'nid',
            'pricing_id',
            'istime',
            'additional_fee_items',
          ].includes(key)
        ) {
          // console.log(key, object[key], typeof object[key])
          const value = object[key]
          // console.log(value)
          if (value && typeof value === 'object') {
            // console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else if (typeof value === 'string' && value.includes('元')) {
            params[key] = value.replace('元', '')
          } else if (typeof value === 'string' && value.includes('吨')) {
            params[key] = value.replace('吨', '')
          } else {
            params[key] = value;
          }
        }
      }
      // 货物id，提交时需要回传
      // params['nid'] = this.detail['nid'] || params['nid'];
      // 派单不传id
      if (!location.href.includes('add')) {
        params['id'] = this.detail['id'];
      }
      if (this.detail['contractid']) {
        params['contractid'] = this.detail['contractid'];
      }
      if (this.detail['pcustomid']) {
        params['pcustomid'] = this.detail['pcustomid'];
      }
      // if (!params['shipperid'] && this.detail['shipperid']) {
      //   params['shipperid'] = this.detail['shipperid'];
      // }

      params['ceton'] = this.detail['ceton'] || this.form['ceton'] || 0

      delete params['pricing_name']
      this.$forceUpdate()
      // console.log('params', { ...params })
    },
  },
  mounted() {
    this.getOptions({ userid: this.user.id });
    // this.getVtype();
    // this.getCar();
  },
}

export default minin